var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.spinClasses,style:(_vm.buttonStyles),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.showAdd)?_c('span',[_vm._v("+")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('span',{staticClass:"loading"}):_vm._e(),_vm._v(" "),_c('span',{class:{dynamic1: _vm.suffix}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d08d9e56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vc-cat/vc-button.vue
// module id = null
// module chunks = 